import { useContext } from 'react';
import {
  ProfileContext,
  ProfileContextValues,
} from '../providers/ProfileProvider';

function useProfile() {
  return useContext(ProfileContext) as ProfileContextValues;
}

export default useProfile;
